var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwipeTutDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11590_608)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 20.5,
    r: 9.5,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 20.5,
    r: 8,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11590_608)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 20.5,
    r: 7.5,
    stroke: "white",
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11590_608",
    x: -5,
    y: -4,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_11590_608"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11590_608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeTutDot);
export default __webpack_public_path__ + "static/media/swipe_tut_dot.386be1390bb1fa151581caa29db18dc7.svg";
export { ForwardRef as ReactComponent };